import {
  SET_BACK_CONTROL_VISIBLE,
  SET_NEXT_CONTROL_DISABLE,
  SET_STEP,
} from "./actions";

export const WizardReducer = (state, action) => {
  const { type } = action;

  if (type === SET_STEP) {
    const { step } = action.payload;

    return {
      ...state,
      step,
    };
  }

  if (type === SET_BACK_CONTROL_VISIBLE) {
    const { hideBackControl } = action.payload;

    return {
      ...state,
      hideBackControl,
    };
  }

  if (type === SET_NEXT_CONTROL_DISABLE) {
    const { disableNextControl } = action.payload;

    return {
      ...state,
      disableNextControl,
    };
  }
  return state;
};
